module.exports = __webpack_public_path__ + "static/img/start.d3b9452.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Glasses/start.jpg
// module id = utcr
// module chunks = 1